export default function TimeAgo(timestamp) {
    const units = [
        { name: "year", millis: 365 * 24 * 60 * 60 * 1000 },
        { name: "month", millis: 30 * 24 * 60 * 60 * 1000 },
        { name: "week", millis: 7 * 24 * 60 * 60 * 1000 },
        { name: "day", millis: 24 * 60 * 60 * 1000 },
        { name: "hour", millis: 60 * 60 * 1000 },
        { name: "minute", millis: 60 * 1000 },
        { name: "second", millis: 1000 }
    ];

    const now = Date.now();
    const elapsed = now - new Date(timestamp).getTime();

    for (const unit of units) {
        const value = Math.floor(elapsed / unit.millis);
        if (value > 0) {
            return `${value} ${unit.name}${value > 1 ? 's' : ''} ago`;
        }
    }

    return "just now";
}